<template>
    <div class="import-page-wrap">
        <div class="back-wrap">
            <span class="back-icon" @click="handleBack"><i class="el-icon-arrow-left"></i>返回</span>
            <span class="back-title">导入</span>
        </div>
        <div class="import-page-main">
            <div class="import-page-content">
                <div class="download-tip">
                    <i></i>
                    <span>请导出列表数据后，在表格中进行编辑，仅支持系统导出的表格格式</span>
                    <el-button @click="handleClickExport">导出</el-button>
                </div>
                <div class="download-wrap">
                    <el-upload
                        class="upload-btn"
                        accept=".xlsx"
                        :auto-upload="false"
                        :on-change="uploadFile"
                        drag
                        action=""
                    ></el-upload>
                    <!-- :on-success="handleSuccess"
                    :before-upload="beforeUpload" -->
                    <img
                        class="download-icon"
                        src="https://download.hecoos.com/enlightv/2024-42/e22ea4a203115fcf34f7057ed61dc242.png"
                        alt=""
                    />
                    <p>将文件拖拽至此，也可以<el-button type="text">【点击上传】</el-button></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import * as XLSX from "xlsx";
import { GetHolidayBalanceList, ImportHolidayBalance } from "@/api";
export default {
    name: "HolidayBalanceImport",
    data() {
        return {
            queryInfo: {
                pageSize: 100,
                department_id: "",
                uid: "",
            },
            exportBtnDisabled: false,
            fileList: [],
        };
    },
    created() {
        if (this.$route.params) {
            this.queryInfo.pageSize = this.$route.params.pageSize;
            this.queryInfo.department_id = this.$route.department_id;
            this.queryInfo.uid = this.$route.uid;
        }
    },
    methods: {
        handleBack() {
            this.$router.replace({
                name: "AttendanceAdminManagement",
                params: {
                    tab: "holidayBalance",
                },
            });
        },
        handleSuccess(response) {},
        beforeUpload(file) {
            // 文件上传前的钩子函数
            console.log(file);
        },
        // 导出
        handleClickExport() {
            this.exportBtnDisabled = true;
            let tableData = [];
            let headers = [
                { field_key: "user_name", field_name: "姓名" },
                { field_key: "department_name", field_name: "部门" },
                { field_key: "joined_date", field_name: "入职时间" },
            ];
            let HeaderInfo = [];
            let params = {
                page: 1,
                pageSize: this.queryInfo.pageSize,
            };
            if (this.queryInfo.department_id) {
                params.department_id = this.queryInfo.department_id;
            }
            if (this.queryInfo.uid) {
                params.uid = this.queryInfo.uid;
            }
            GetHolidayBalanceList(params)
                .then((res) => {
                    if (res.code === 200) {
                        const { data, header, total } = res.data;
                        header.forEach((item) => {
                            headers.push({
                                field_key: "holiday_config_id" + item.holiday_config_id,
                                field_name: item.name,
                                field_type: "holiday_config_id",
                                holiday_config_id: item.holiday_config_id,
                            });
                        });
                        HeaderInfo = headers.map((item) => item.field_name);
                        tableData = data.map((item) => {
                            let itemdata = [];
                            headers.forEach((field) => {
                                if (field.field_type) {
                                    // 自定义字段
                                    const find_item = item.holiday_balances.find(
                                        (item) => item.holiday_config_id === field.holiday_config_id
                                    );
                                    itemdata.push(find_item ? find_item.balance : "");
                                } else {
                                    // 固定字段
                                    itemdata.push(item[field.field_key]);
                                }
                            });
                            return itemdata;
                        });
                        // 数据结构
                        // const data = [
                        //     ["姓名", "年龄"],
                        //     ["刘XX", 1],
                        // ];
                        const xlsxData = [HeaderInfo, ...tableData];
                        const ws = XLSX.utils.aoa_to_sheet(xlsxData);
                        const wb = XLSX.utils.book_new();
                        XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
                        const fileName = this.nowDate();
                        setTimeout(() => {
                            XLSX.writeFile(wb, fileName);
                            this.$message.success("导出成功");
                        }, 2000);
                    }
                    this.exportBtnDisabled = false;
                })
                .catch(() => {
                    this.exportBtnDisabled = false;
                });
        },
        nowDate(type) {
            const today = new Date();
            const year = today.getFullYear();
            let month = today.getMonth() + 1;
            month = month < 10 ? "0" + month : month;
            const date = today.getDate() < 10 ? "0" + today.getDate() : today.getDate();
            const hours = today.getHours();
            const minutes = today.getMinutes();
            const seconds = today.getSeconds() < 10 ? "0" + today.getSeconds() : today.getSeconds();
            if (type && type == "date") {
                return `${year}-${month}-${date}`;
            } else if (type && type == "date2") {
                return `${year}-${month}`;
            } else {
                return `员工假期余额${year}年${month}月${date}日${hours}时${minutes}分${seconds}秒.xlsx`;
            }
        },
        uploadFile(file, fileList) {
            this.fileList = fileList;
            console.log(file, fileList)
            this.$nextTick(()=> {
                this.submitUpload()
            })
        },
        submitUpload() {
            const formData = new FormData();
            formData.append("file", this.fileList[0].raw);
            ImportHolidayBalance(formData).then(res=> {
                if(res.code === 200) {
                    console.log(res, 'res====')
                    this.$message.success(res.message)
                } else {
                    this.$message.error(res.message)
                }
            })
        },
    },
};
</script>

<style lang="scss" scoped>
.import-page-wrap {
    height: 100%;
    .back-wrap {
        padding: 12px 0 12px 18px;
        border-bottom: 1px solid rgba(232, 232, 232, 1);
        font-size: 16px;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 24px;
        color: rgba(102, 102, 102, 1);
        display: flex;
        align-items: center;

        .back-icon {
            border-radius: 4px;
            cursor: pointer;

            &:hover {
                background-color: rgba(0, 0, 0, 0.04);
                color: rgba(51, 51, 51, 1);
            }
        }

        .back-title {
            font-weight: 700;
            color: rgba(51, 51, 51, 1);
            padding-left: 17px;
            position: relative;

            &::before {
                content: "";
                position: absolute;
                left: 8px;
                top: 4px;
                width: 1px;
                height: 16px;
                background: rgba(232, 232, 232, 1);
            }
        }
    }
    .import-page-main {
        height: calc(100% - 49px);
        padding: 24px 148px 26px;
    }
    .import-page-content {
        margin: 0 auto;
        max-width: 984px;
        position: relative;
    }
    .download-tip {
        width: 100%;
        height: 54px;
        border-radius: 8px;
        background: rgba(203, 225, 245, 1);
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 22px;
        color: rgba(25, 144, 255, 1);

        & > .iconfont {
            margin-right: 8px;
        }

        .el-button {
            margin-left: 8px;
            padding: 0;
            width: 88px;
            height: 32px;
            opacity: 1;
            border-radius: 52px;
            background: rgba(255, 255, 255, 1);

            border: 1px solid rgba(25, 144, 255, 1);
            text-align: center;
            line-height: 32px;
            color: rgba(25, 144, 255, 1);
            font-weight: 400;
        }

        &.download-tip-warn {
            background-color: rgba(252, 238, 214, 1);
            color: rgba(240, 170, 50, 1);

            .icon-jinggao {
                color: rgba(240, 170, 50, 1);
            }
        }
        &.download-tip-success {
            background: rgba(222, 240, 214, 1);
            color: rgba(90, 179, 51, 1);
            i {
                color: rgba(90, 179, 51, 1);
                font-size: 16px;
            }
        }
    }
    .download-wrap {
        margin-top: 36px;
        width: 100%;
        height: 582px;
        border-radius: 8px;
        background: rgba(247, 248, 250, 1);
        border: 2px dashed rgba(217, 217, 217, 1);
        box-shadow: 0px 12px 48px 16px rgba(0, 0, 0, 0.03);
        padding-top: 200px;
        text-align: center;
        position: relative;

        .download-icon {
            width: 140px;
        }

        .import_wrap_percentage {
            width: 69.1%;
            margin: 16px auto;
        }

        .upload-text {
            font-size: 18px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 28px;
            color: rgba(51, 51, 51, 1);
            text-align: center;
        }
    }
    .upload-btn {
        width: 100%;
        height: 100%;
        display: block;
        z-index: 20;
        opacity: 0;
        cursor: pointer;
        position: absolute;
        left: 0;
        top: 0;
        ::v-deep {
            .el-upload {
                display: block;
                width: 100%;
                height: 100%;
            }
        }
    }
}
</style>
